module.exports = __webpack_public_path__ + "static/media/underDocuments.c2ff215e.png";